import React, { useEffect, useState } from 'react'
import { Dropdown, Grid, Icon, Rail } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import { SetSearchArea  } from "../../../../redux/actions/mainActions"
import "./SearchLocation.css"
import LocationTab from '../../../mobile/components/LocationTab/LocationTab';
const initialState = { isLoading: false, results: [], value: '' }

const SearchLocation = ({ setShowLocationTab }) => {
  const dispatch = useDispatch()
  const source = [
    { value: 'af', image: "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg", text: 'Afghanistan' },
    { value: 'ax', image: "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg", text: 'Aland Islands' },
    { value: 'al', image: "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg", text: 'Albania' },
    { value: 'dz', image: "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg", text: 'Algeria' },
    { value: 'as', image: "https://cdn.pixabay.com/photo/2021/08/25/20/42/field-6574455__340.jpg", text: 'American Samoa' },
   
  ]



  const searchArea = useSelector((state) => state.main.searchArea)


  

  const handleSearchChange = (e, {value}) => {
    dispatch(SetSearchArea(value))
        
  }

  useEffect(()=>{
    console.log(searchArea)
  },[searchArea])

  return <Grid centered verticalAlign="middle" >
  

    <Grid.Column width={16}>

      <Dropdown
      icon="search"
      placeholder='Where are you going'
      fluid
      search
      selection
      //clearable
      options={source}
      className="search-location"
      onChange={(e,data)=>handleSearchChange(e,data)}
    />
    <LocationTab/>
     
    </Grid.Column>
  </Grid>
}
export default SearchLocation